import ListItemText from "@mui/material/ListItemText";

export default ListItemText;
